import revive_payload_client_4sVQNw7RlN from "/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/tmp/menaceking-build-1753204313/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/tmp/menaceking-build-1753204313/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/tmp/menaceking-build-1753204313/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_hwlJ5PmHMh from "/tmp/menaceking-build-1753204313/node_modules/nuxt-lazy-load/dist/runtime/plugin.mjs";
import plugin_Jozdw60ZsE from "/tmp/menaceking-build-1753204313/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import click_outside_directive_YjNOGbcjIP from "/tmp/menaceking-build-1753204313/plugins/click-outside-directive.ts";
import error_handling_nfXsHBWcke from "/tmp/menaceking-build-1753204313/plugins/error-handling.ts";
import ga_user_id_client_rMOoEIPcZI from "/tmp/menaceking-build-1753204313/plugins/ga-user-id.client.ts";
import gtm_client_OzmBuHLRIb from "/tmp/menaceking-build-1753204313/plugins/gtm.client.ts";
import gtmAnalytics_OhqfaCHZiL from "/tmp/menaceking-build-1753204313/plugins/gtmAnalytics.ts";
import hotjar_client_HJG8no80GI from "/tmp/menaceking-build-1753204313/plugins/hotjar.client.ts";
import maska_UHaKf2z1iQ from "/tmp/menaceking-build-1753204313/plugins/maska.ts";
import setup_client_LCITs7LDia from "/tmp/menaceking-build-1753204313/plugins/setup.client.ts";
import vue_final_modal_pML93k5qcp from "/tmp/menaceking-build-1753204313/plugins/vue-final-modal.ts";
import vue_notify_cnxBSgMk18 from "/tmp/menaceking-build-1753204313/plugins/vue-notify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  plugin_hwlJ5PmHMh,
  plugin_Jozdw60ZsE,
  click_outside_directive_YjNOGbcjIP,
  error_handling_nfXsHBWcke,
  ga_user_id_client_rMOoEIPcZI,
  gtm_client_OzmBuHLRIb,
  gtmAnalytics_OhqfaCHZiL,
  hotjar_client_HJG8no80GI,
  maska_UHaKf2z1iQ,
  setup_client_LCITs7LDia,
  vue_final_modal_pML93k5qcp,
  vue_notify_cnxBSgMk18
]